import myfun from "../../public/myfun.js"
import CryptoJS from 'crypto-js';
import myDB from "../../public/myDB.js"
export default {
	namespaced: true,
	state: ()=>({
		sch:null,
		typ:null,
		v2l:{
			nj:["一年级","二年级","三年级","四年级","五年级","六年级","初一","初二","初三","高一","高二","高三"],
			xq:["上学期","下学期"],
			filetyp:["文字版","图片版"],
			answer:["","含答案","独立文件","无答案"]
		},
		allsub:null,
		uplist:[],
		downlist:[]
	}),
	getters:{
		getsch(state){
			if(state.sch){
				return state.sch
			}
			if(sessionStorage.getItem("librarysch")){
				state.sch=JSON.parse(sessionStorage.getItem("librarysch"))
				return state.sch
			}
			return []
		},
		getalltyp(state){
			if(state.typ){
				return state.typ
			}
			if(sessionStorage.getItem("librarytyp")){
				state.typ=JSON.parse(sessionStorage.getItem("librarytyp"))
				return state.typ
			}
			return []
		},
		gettypByNj:(state)=>(xd)=>{
			let arr=[]
			if(!state.typ){
				let typ=JSON.parse(sessionStorage.getItem("librarytyp"))
				state.typ=typ?typ:[]
			}
			state.typ.forEach(e=>{
				if(e.nj==="全部"||e.nj===xd){
					arr.push(e)
				}
			})
			return arr
		},
		getselitem:(state)=>(year,typid,xd)=>{
			let obj={}
			//学年
			obj.years=[]
			let b=false
			if(typid>=7&&typid<=9){
				b = true
			}
			for(let i=year;i>=2000;i--){
				obj.years.push({value:i,label:b?`${i}年`:`${i}-${i+1}学年`})
			}
			//年级
			obj.nj=[]
			if(xd){
				let arr=state.v2l.nj.map((e,i)=>{
					return {id:i,nj:e}
				})
				switch(xd){
				case "小学":
					obj.nj=arr.slice(0,6)
					break
				case "初中":
					obj.nj=arr.slice(6,9)
					break
				case "高中":
					obj.nj=arr.slice(9,12)
					break
				}
			}
			//学期
			obj.xq=state.v2l.xq.map((e,i)=>{
				return {id:i,xq:e}
			})
			//文件类型
			obj.filetyp=state.v2l.filetyp.map((e,i)=>{
				return {id:i,typ:e}
			})
			//控制
			obj.disable={sch:false,nj:false,xq:false}
			if(typid===7||(typid>=12&&typid<=17)){
				obj.disable={sch:false,nj:true,xq:true}
			}
			if(typid===8||typid===9){
				obj.disable={sch:true,nj:true,xq:true}
			}
			return obj
		},
		getansweritem(state){
			let arr=[]
			for(let i=1;i<state.v2l.answer.length;i++){
				arr.push({id:i,name:state.v2l.answer[i]})
			}
			return arr
		},
		testvalue:(state)=>(test)=>{
			let obj={}
			//年份
			obj.year=`${test.year}-${test.year+1}学年`
			if(test.typ>=7&&test.typ<=9){
				obj.year=`${test.year}年`
			}
			//科目
			if(!state.allsub){
				let base=JSON.parse(sessionStorage.getItem("baseData"))
				state.allsub=base?base.allSub:[]
			}
			let sub=state.allsub.find(e=>e.id===test.sub)
			obj.sub={nj:sub?sub.nj:"-",sub:sub?sub.sub:"-"}
			//类型
			if(!state.typ){
				state.typ=JSON.parse(sessionStorage.getItem("librarytyp"))
			}
			let typ=state.typ.find(e=>e.id===test.typ)
			obj.typ=typ?typ.typ:""
			//学校
			if(!state.sch){
				state.sch=JSON.parse(sessionStorage.getItem("librarysch"))
			}
			let sch=state.sch.find(e=>e.id===test.sch)
			obj.sch=sch?sch.sch:"-"
			//年级
			if(test.nj<0){
				obj.nj="="
			}else{
				obj.nj=state.v2l.nj[test.nj]
			}
			//学期
			if(test.xq<0){
				obj.xq="-"
			}else{
				obj.xq=state.v2l.xq[test.xq]
			}
			//文件类型
			obj.filetyp=state.v2l.filetyp[test.filetyp]
			//答案
			obj.answer=state.v2l.answer[test.answer]
			//文件名
			obj.name=obj.year+(obj.sch!=="-"?obj.sch:"")
			if(test.typ<=6||test.typ===10||test.typ===11||test.typ>17){
				obj.name+=obj.nj+obj.xq
			}
			obj.name+=obj.typ+obj.sub.sub+"试卷"
			if(test.num>1){
				obj.name+=`(${test.num})`
			}
			obj.name+="-"+obj.filetyp
			
			return obj
		},
		getLineList(state){
			return {up:state.uplist,down:state.downlist}
		},
	},
	mutations:{
		setsch(state,data){
			state.sch=data
			sessionStorage.setItem("librarysch",JSON.stringify(data))
		},
		addtestsch(state,data){
			if(!state.sch){
				if(sessionStorage.getItem("librarysch")){
					state.sch=JSON.parse(sessionStorage.getItem("librarysch"))
				}else{
					state.sch=[]
				}
			}
			state.sch.push(data)
		},
		settyp(state,data){
			state.typ=data
			sessionStorage.setItem("librarytyp",JSON.stringify(data))
		},
		addUplist(state,{data,fun}){
			//查询是否在列表中
			const obj=state.uplist.find(e=>e.test.id===data.test.id)
			if(obj && typeof obj.file.typ=== typeof data.file.typ){
				fun("文件已在上传列表中，请勿重复上传")
				return
			}
			state.uplist.push(data)
			runup(state.uplist)
			fun()
		},
		addDownlist(state,{data,fun}){
			const obj=state.downlist.find(e=>e.test.id===data.test.id)
			if(obj && typeof obj.file.typ=== typeof data.file.typ){
				fun("文件已在下载列表中，请勿重复下载")
				return
			}
			state.downlist.push(data)
			rundown(state.downlist)
			fun()
		},
	},
}
const slicesize=128*1024
const fileurl="http://47.109.80.27:7070/"
var token=null
//上传
var upindex = 0
var uping = false
const runup= async function(uplist){
	if(uping){
		return
	}
	uping=true
	let lastup=0
	const fun=function(loaded,total){
		uplist[upindex].file.nowsize += loaded-lastup
		if(loaded===total){
			lastup=0
		}else{
			lastup=loaded
		}
		
	}
	await uptest(uplist[upindex],fun)
	upindex++
	uping=false
	if(upindex<uplist.length){
		runup(uplist)
		return
	}
	upindex=0
}
const uptest= async function(test,fun){
	if(test.file.nowsize>=test.file.size){
		return
	}
	if(test.file.typ==='analyse'){
		await upfile(test.file,"analysefile",fun)
		return
	}
	await upfile(test.file,"testfile",fun)
	if(test.file.answerfile){
		await upfile(test.file,"answerfile",fun)
	}
}
const upfile= async function(file,name,fun){
	let i=0
	const onefile=file[name]
	const _up=async function(){
		try {
			await upslice(onefile,file.key,i,name,fun)
		} catch(e){
			myfun.messageErrClose(e)
		}
		i++
		if(i*slicesize<onefile.size){
			await _up()
			return
		}
	}
	await _up()
}
const upslice= function(file,key,i,name,fun){
	const start = i*slicesize
	const end = (i+1)*slicesize<file.size?(i+1)*slicesize:file.size
	const data=file.slice(start,end)
	return new Promise((resolve, reject)=>{
		let reader = new FileReader()
		reader.onload=(e)=>{
			let filedata=e.target.result
			let wordarr=CryptoJS.lib.WordArray.create(filedata)
			let md5=CryptoJS.MD5(wordarr).toString()
			//验证md5
			let prexhr=new XMLHttpRequest()
			prexhr.open("POST",fileurl+"preupfile")
			if(!token){
				token=sessionStorage.getItem("token")
			}
			prexhr.setRequestHeader("Token",token)
			prexhr.setRequestHeader("key",key)
			prexhr.setRequestHeader("index",i)
			prexhr.setRequestHeader("name",name)
			const formdata = new FormData()
			formdata.append("md5",md5)
			prexhr.onload=function(){
				if(prexhr.status>=200&&prexhr.status<300){
					let res = JSON.parse(prexhr.response)
					if(res.ok){
						fun(data.size,data.size)
						resolve("ok")
						return
					}
				}
				prexhr.onerror()
			}
			prexhr.onerror=function(){
				let xhr = new XMLHttpRequest()
				xhr.open("POST",fileurl+"upfile")
				if(!token){
					token=sessionStorage.getItem("token")
				}
				xhr.setRequestHeader("Token",token)
				xhr.setRequestHeader("key",key)
				xhr.setRequestHeader("index",i)
				xhr.setRequestHeader("name",name)
				xhr.setRequestHeader("md5",md5)
				xhr.setRequestHeader("Content-Type","multipart/form-data")
				xhr.upload.addEventListener("progress",(e)=>{
					fun(e.loaded,e.total)
				})//请求监控
				//xhr.addEventListener("progress",fun)//响应监控
				xhr.onload=function(){
					if(xhr.status>=200&&xhr.status<300){
						let res=JSON.parse(xhr.response)
						if(res.ok){
							resolve("ok")
						}else{
							reject(new Error(res.err))
						}
					}else{
						reject(new Error(xhr.statusText))
					}
				}
				xhr.onerror=function(){
					reject(new Error("Network Error"))
				}
				xhr.send(data)
			}
			prexhr.send(formdata)
		}
		reader.readAsArrayBuffer(data)
	})
}

//下载
var downindex=0
var downing=false
var filetyp={
	doc:"application/msword",
	docx:"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	pdf:"application/pdf",
}
const rundown=async function(downlist){
	if(downing){
		return
	}
	downing=true
	const fun =function(e){
		downlist[downindex].file.nowsize+=e
	}
	try{
		await downtest(downlist[downindex],fun)
	}catch(e){
		myfun.messageErrClose(e)
	}
	downindex++
	downing=false
	if(downindex<downlist.length){
		rundown(downlist)
		return
	}
	downindex=0
}
const downtest=async function(test,fun){
	if(test.file.nowsize>=test.file.size){
		return
	}
	if(test.file.typ==='analyse'){
		let length = test.file.size/slicesize
		let analyse = []
		for(let i=0;i<length;i++){
			let data = await downlice(test,fun,"analyse",i)
			analyse.push(data)
		}
		savetest(test,"analyse",analyse)
		return
	}
	//下载文件
	let testlength = test.test.size/slicesize
	let tests=[]
	for(let i=0;i<testlength;i++){
		let data = await downlice(test,fun,"test",i)
		tests.push(data)
	}
	savetest(test,"test",tests)
	//下载答案
	if(test.file.typ===2){
		let answer=[]
		let answerlength=test.test.asize/slicesize
		for(let i=0;i<answerlength;i++){
			let data = await downlice(test,fun,"answer",i)
			answer.push(data)
		}
		savetest(test,"answer",answer)
	}
}
const downlice=async function(test,fun,name,index){
	let filename=test.test.id+name+index
	return new Promise((resolve, reject)=>{
		myDB.select(filename,async (b,data)=>{
			if(b){
				//验证md5
				if(data.md5){
					//改为Promise
					let res= await md5istrue(test,name,index,data.md5)
					if(res){
						fun(data.file.size)
						resolve(data.file)
						return
					}
				}
			}
			downfile(test,fun,name,index,(e)=>{
				if(e.ok){
					resolve(e.data.file)
					//缓存数据库
					myDB.insert({
						name:filename,
						md5:e.data.md5,
						file:e.data.file
					})
					return
				}
				reject(e.err)
			})
		})
	})
}
const downfile=function(test,fun,name,index,back){
	let xhr = new XMLHttpRequest()
	xhr.open("POST",fileurl+"downfile")
	if(!token){
		token=sessionStorage.getItem("token")
	}
	xhr.setRequestHeader("Token",token)
	xhr.setRequestHeader("key",test.file.key)
	xhr.setRequestHeader("index",index)
	xhr.setRequestHeader("name",name)
	let lastsize=0
	xhr.addEventListener("progress",(e)=>{
		let ok=xhr.getResponseHeader("Isok")
		if(ok==="yes"){
			fun(e.loaded-lastsize)
			lastsize=e.loaded
		}
	})//响应监控
	xhr.responseType = "blob"
	xhr.onload=function(){
		if(xhr.status>=200&&xhr.status<300){
			let ok=xhr.getResponseHeader("Isok")
			if(ok==="yes"){
				let md5=xhr.getResponseHeader("Md5")
				back({ok:true,data:{file:xhr.response,md5:md5}})
				return
			}
			let reader = new FileReader()
			reader.readAsText(xhr.response,"utf-8")
			reader.addEventListener("loadend",()=>{
				let res = JSON.parse(reader.result)
				back(res)
			})
		}else{
			back({ok:false,err:new Error(xhr.statusText)})
		}
	}
	xhr.onerror=function(){
		back({ok:false,err:new Error("Network Error")})
	}
	xhr.send()
}
const md5istrue=function(test,name,index,md5){
	return new Promise((resolve)=>{
		let xhr = new XMLHttpRequest()
		xhr.open("POST",fileurl+"havefile")
		if(!token){
			token=sessionStorage.getItem("token")
		}
		xhr.setRequestHeader("Token",token)
		xhr.setRequestHeader("key",test.file.key)
		xhr.setRequestHeader("index",index)
		xhr.setRequestHeader("name",name)
		xhr.setRequestHeader("md5",md5)
		xhr.onload=function(){
			if(xhr.status>=200&&xhr.status<300){
				let res=JSON.parse(xhr.response)
				if(res.ok){
					resolve(true)
				}
			}
			resolve(false)
		}
		xhr.onerror=function(){
			resolve(false)
		}
		xhr.send()
	})
}
const savetest=function(inf,typ,blobs){
	//生成文件
	let filename=inf.value.name
	let testtyp=""
	if(typ==="test"){
		filename+="."+inf.test.suffix
		testtyp=inf.test.suffix
	}else if(typ==="answer"){
		filename+="_答案."+inf.test.asuffix
		testtyp=inf.test.asuffix
	}else{
		filename+="_试卷分析."+inf.test.analyseSuffix
		testtyp=inf.test.analyseSuffix
	}
	let file=new Blob(blobs,{type:filetyp[testtyp]})
	let href=window.URL.createObjectURL(file)
	//下载
	let a = document.createElement("a")
	a.href=href
	a.download=filename
	a.style.display="none"
	document.body.appendChild(a)
	a.click()
	document.body.removeChild(a)
	window.URL.revokeObjectURL(href)
}